/* eslint-disable max-len */
export const MOBILE_UPLOAD_CONFIRMATION_SCREEN_DICT = { mailingAddress: 'ChangeMailingAddressConfirmation' };

export const MOBILE_UPLOAD_FAILURE_SCREEN_DICT = { mailingAddress: 'MailingAddressUploadReviewDocument' };
